import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { saveAs } from 'file-saver';
import { NGXLogger } from 'ngx-logger';
import { DataTable } from 'primeng/components/datatable/datatable';
import { Subscription } from 'rxjs';
import { Customer } from '../../models/customer.model';
import { FacilityType } from '../../models/facility-type.model';
import { Permission } from '../../models/permission.model';
import { SPContractBase } from '../../models/sp-contract-base.model';
import { AccountService } from '../../services/account.service';
import { AlertService, DialogType, MessageSeverity } from '../../services/alert.service';
import { fadeInOut } from '../../services/animations';
import { ContractBaseService } from '../../services/contract-base.service';
import { ContractFileService } from '../../services/contract-file.service';
import { CustomersService } from '../../services/customers.service';
import { DeliveryAddressService } from '../../services/delivery-address.service';
import { EANCodeService } from '../../services/ean-code.service';
import { ElectricityContractService } from '../../services/electricity-contract.service';
import { FacilityTypeService } from '../../services/facility-type.service';
import { GasContractService } from '../../services/gas-contract.service';
import { Utilities } from '../../services/utilities';

// let _ = require('lodash');

@Component({
    selector: 'customers-add-update',
    template: require('./customers-add-update.component.html'),
    styles: [require('./customers-add-update.component.css')],
    animations: [fadeInOut]
})
export class CustomersAddUpdateComponent implements OnInit, OnDestroy {
    private subscribers: Subscription[] = [];

    mode: string = "Opslaan";
    customer: Customer = new Customer;
    eanCodes: any[] = [];
    linkedGroup: Customer[] = [];
    facilityTypes: FacilityType[] = [];
    loading: boolean = false;
    display1: boolean = false;
    display2: boolean = false;
    selectedData: any;
    contractBases: SPContractBase[] = [];
    selectedContracts: SPContractBase[] = [];

    isDisableControl: boolean = false;
    isElectricityContractManage: boolean = false;
    isInjectionContractManage: boolean = false;
    isGASContractManage: boolean = false;
    ddRegisterTypes: Array<{ label: string, value: string }> = new Array();

    constructor(private accountService: AccountService, private customersService: CustomersService, private deliveryAddressService: DeliveryAddressService,
        private electricityContractService: ElectricityContractService, private gasContractService: GasContractService, private contractFileService: ContractFileService,
        private facilityTypeService: FacilityTypeService, private eanCodeService: EANCodeService, private contractBaseService: ContractBaseService,
        private router: Router, private activatedRoute: ActivatedRoute, private alertService: AlertService, private ngxLogger: NGXLogger) { }

    ngOnInit() {
        this.ddRegisterTypes = [
            { label: 'Bedrijf', value: 'B' },
            { label: 'Particulier', value: 'P' }
        ];

        const getSub = this.facilityTypeService.get().subscribe((res: FacilityType[]) => {
            this.facilityTypes = res;
        });
        this.subscribers.push(getSub);

        this.customer.CustomerType = "Solo";
        if (this.canviewCustomers) {
            this.isDisableControl = true;
        }

        if (this.caneditCustomers) {
            this.isDisableControl = false;
        }

        if (this.caneditCustomers && this.canviewCustomers) {
            this.isDisableControl = false;
        }

        if (this.canviewCustomers && this.caneditCustomers == false) {
            this.isDisableControl = true;
        }

        if (this.canelectricityContractAdd || this.canelectricityContractDelete || this.canelectricityContractEdit || this.canelectricityContractList || this.canelectricityContractView) {
            this.isElectricityContractManage = true;
        }

        if (this.caninjectionContractAdd || this.caninjectionContractDelete || this.caninjectionContractEdit || this.caninjectionContractList) {
            this.isInjectionContractManage = true;
        }

        if (this.canGASContractAdd || this.canGASContractDelete || this.canGASContractEdit || this.canGASContractList || this.canGASContractView) {
            this.isGASContractManage = true;
        }

        const paramSub = this.activatedRoute.params.subscribe(params => {
            if (params['id']) {
                this.customer.Id = params['id'];
                this.mode = "Bewerken";
                this.getById();
                this.getEANCodeByCustomer();
                this.getLinkedGroup();
            }
        });
        this.subscribers.push(paramSub);
    }

    customExport(dt: DataTable) {
        const hiddenColumns: any[] = [];
        dt.columns.forEach((c) => {
            // search for whatever criteria you care for.  in my use case if the column is hidden i don't want to export that data
            if (c.hidden === true) {
                hiddenColumns.push({ field: c.field, col: c });
                c.field = '';
            }
        });
        dt.exportCSV();
        // Restore their fields so data binding and such still works in the future
        hiddenColumns.forEach((hc) => {
            hc.col.field = hc.field;
        });
    }

    createUpdate() {
        if (this.customer.CustomerRegistrationType === 'P') {
            this.customer.Company = null;
            this.customer.BTW = null;
        }
        const createUpdateSub = this.customersService.createUpdate(this.customer).subscribe((customer: Customer) => {
            if (customer) {
                this.alertService.showMessage('Klanten', 'Aanpassingen met succes bewaard!', MessageSeverity.success);
                this.router.navigate(['customer/edit', customer.Id]);
            }
        }, error => {
            const errorMessage = Utilities.findHttpResponseMessage("error_description", error);
            if (errorMessage == 'Email Exists') {
                this.alertService.showMessage('Al Bestaat', this.customer.Email + " met  " + this.customer.Company + " bedrijf bestaat al!", MessageSeverity.warn);
            } else if (errorMessage == 'BTW Exists') {
                this.alertService.showMessage(this.customer.BTW, 'BTW bestaat al!', MessageSeverity.warn);
            } else {
                this.alertService.showStickyMessage('Fout', 'Er is iets fout gegaan', MessageSeverity.error);
            }
        });
        this.subscribers.push(createUpdateSub);
    }

    getById() {
        this.getContractBaseFromCustomerId();
        this.loading = true;
        const getCustomerSubscriber = this.customersService.getCustomerById(this.customer.Id).subscribe((res: Customer) => {
            this.customer = res;
            // this.contractBases = this.customer.ContractBases.filter(c => c.IsActive == true);
            // // check Electriciteit, Injectie & Gas  for permissions
            // if (!this.canelectricityContractList && !this.canelectricityContractEdit && !this.canelectricityContractView && !this.canelectricityContractDelete) {
            //     this.contractBases = this.contractBases != null ? this.contractBases.filter(f => f.FacilityType != null && f.FacilityType.Id !== 1) : null;
            // } else if (!this.caninjectionContractList && !this.caninjectionContractEdit && !this.caninjectionContractView && !this.caninjectionContractDelete) {
            //     this.contractBases = this.contractBases != null ? this.contractBases.filter(f => f.FacilityType != null && f.FacilityType.Id !== 3) : null;
            // } else if (!this.canelectricityContractList && !this.canelectricityContractEdit && !this.canelectricityContractView && !this.canelectricityContractDelete) {
            //     this.contractBases = this.contractBases != null ? this.contractBases.filter(f => f.FacilityType != null && f.FacilityType.Id !== 2) : null;
            // }
            this.customer.CustomerRegistrationType = this.customer.BTW !== '' && this.customer.BTW !== null ? 'B' : 'P';
            this.loading = false;
        }, error => {
            this.loading = false;
            this.ngxLogger.error(error.message);
            throw error;
        });
        this.subscribers.push(getCustomerSubscriber);
    }

    getContractBaseFromCustomerId() {
        const getContractBaseFromCustomerIdSub = this.contractBaseService.getContractBaseFromCustomerId(this.customer.Id).subscribe((res: SPContractBase[]) => {
            this.contractBases = res;
            if (this.contractBases != null && this.contractBases.length > 0) {
                this.contractBases = this.contractBases.filter(f => f.IsActive);
                // check Electriciteit, Injectie & Gas  for permissions
                if (!this.canelectricityContractList && !this.canelectricityContractEdit && !this.canelectricityContractView && !this.canelectricityContractDelete) {
                    this.contractBases = this.contractBases != null ? this.contractBases.filter(f => f.FacilityTypeName != null && f.FacilityTypeId !== 1) : null;
                } else if (!this.caninjectionContractList && !this.caninjectionContractEdit && !this.caninjectionContractView && !this.caninjectionContractDelete) {
                    this.contractBases = this.contractBases != null ? this.contractBases.filter(f => f.FacilityTypeName != null && f.FacilityTypeId !== 3) : null;
                } else if (!this.canelectricityContractList && !this.canelectricityContractEdit && !this.canelectricityContractView && !this.canelectricityContractDelete) {
                    this.contractBases = this.contractBases != null ? this.contractBases.filter(f => f.FacilityTypeName != null && f.FacilityTypeId !== 2) : null;
                }
            }
            this.loading = false;
        }, error => {
            this.ngxLogger.error(error.message);
            throw error;
        });
        this.subscribers.push(getContractBaseFromCustomerIdSub);
    }

    getEANCodeByCustomer() {
        const getEANCodeSubscriber = this.eanCodeService.getEANCodeByCustomer(this.customer.Id)
            .subscribe((res: any[]) => {
                this.eanCodes = res;
            }, error => {
                this.ngxLogger.error(error.message);
                throw error;
            });
        this.subscribers.push(getEANCodeSubscriber);
    }

    getLinkedGroup() {
        const getLinkGrpSubscriber = this.customersService.getLinkedGroup(this.customer.Id).subscribe((res: Customer[]) => {
            this.linkedGroup = res;
        }, error => {
            this.ngxLogger.error(error.message);
            throw error;
        });
        this.subscribers.push(getLinkGrpSubscriber);
    }

    deleteDeliveryAddress() {
        const deleteaddressSubscriber = this.deliveryAddressService.delete(this.selectedData.DeliveryAddress.Id).subscribe(res => {
            this.alertService.showMessage('Leveringsadres', 'Met succes verwijderd!', MessageSeverity.success);
            this.getById();
            this.getEANCodeByCustomer();
            this.display1 = false;
            this.display2 = false;
        }, error => {
            this.ngxLogger.error(error.message);
            throw error;
        });
        this.subscribers.push(deleteaddressSubscriber);
    }

    deleteEanCode() {
        const deleteeanCodeSubscriber = this.eanCodeService.delete(this.selectedData.EANCode.Id).subscribe(res => {
            this.alertService.showMessage('EAN Code', 'Met succes verwijderd!', MessageSeverity.success);
            this.getById();
            this.getEANCodeByCustomer();
            this.display1 = false;
            this.display2 = false;
        }, error => {
            this.ngxLogger.error(error.message);
            throw error;
        });
        this.subscribers.push(deleteeanCodeSubscriber);
    }

    exportAddressExcel() {
        if (this.eanCodes.length > 0) {
            let ids: string = "0";

            this.alertService.showMessage('Leveringsadressen', 'Bestandsdownload is bezig!', MessageSeverity.info);
            const exportExcelSubscribe = this.eanCodeService.exportExcel(ids, this.customer.Id).subscribe(data => {
                saveAs(data, 'Leveringsadressen.xlsx');
                this.alertService.showMessage('Leveringsadressen', 'Bestandsdownload voltooid!', MessageSeverity.info);
            }, error => {
                this.ngxLogger.error(error.message);
                throw error;
            });
            this.subscribers.push(exportExcelSubscribe);
        } else {
            this.alertService.showMessage('Leveringsadressen', 'Geen Leveringsadressen gevonden!', MessageSeverity.warn);
        }
    }

    editContract(contractBase: SPContractBase) {
        switch (contractBase.FacilityTypeId) {
            case 1:
                this.router.navigate(['electricitycontract', contractBase.CType, contractBase.CustomerId, contractBase.Id]);
                break;
            case 2:
                this.router.navigate(['gascontract', contractBase.CType, contractBase.CustomerId, contractBase.Id]);
                break;
            case 3:
                this.router.navigate(['injectiecontract', contractBase.CType, contractBase.CustomerId, contractBase.Id]);
                break;
            default:
                break;
        }
    }

    viewFile(id: number, facilityTypeId: number) {
        this.alertService.showMessage('Klanten', 'Even geduld aub terwijl we een bestand van de server krijgen!', MessageSeverity.info);
        const getElectricitySubscriber = this.contractFileService.getAllByFacility(facilityTypeId, id).subscribe((res: any[]) => {
            if (res.length > 0) {
                if (res.length == 1) { // VIEW SINGLE FILE
                    const viewFileSubscriber = this.contractFileService.viewFile(facilityTypeId, id, res[0].Id).subscribe(data => {
                        const url = window.URL.createObjectURL(data);
                        const iFrameElement = <HTMLIFrameElement>document.getElementById('iFrameContent');
                        iFrameElement.setAttribute('src', url);
                        iFrameElement.setAttribute('type', data.type);
                        (<HTMLButtonElement>document.getElementById('btnmyModelPopup')).click();
                    }, error => {
                        this.ngxLogger.error(error.message);
                        throw error;
                    });
                    this.subscribers.push(viewFileSubscriber);
                } else if (res.length > 1) {  // DOWNLOAD ZIP
                    const viewFileSubscriber = this.contractFileService.viewFile(facilityTypeId, id, res[0].Id).subscribe(data => {
                        saveAs(data, 'Contracts.zip');
                        this.alertService.showMessage('Klanten', 'Bestandsdownload voltooid!', MessageSeverity.info);
                    }, error => {
                        this.ngxLogger.error(error.message);
                        throw error;
                    });
                    this.subscribers.push(viewFileSubscriber);
                }
            } else {
                this.alertService.showMessage('Klanten', 'Geen document gevonden voor dit contract!', MessageSeverity.info);
            }
        }, error => {
            this.ngxLogger.error(error.message);
            throw error;
        });
        this.subscribers.push(getElectricitySubscriber);
    }

    deleteContract(contractId: number, facilityTypeId: number) {
        switch (facilityTypeId) {
            case 1:
                this.alertService.showDialog('Weet je zeker dat je wilt verwijderen?', DialogType.confirm, () => {
                    const deleteConSubscriber = this.electricityContractService.delete(contractId).subscribe(res => {
                        this.alertService.showMessage('Elektriciteitscontract', 'Met succes verwijderd!', MessageSeverity.success);
                        this.getById();
                    }, error => {
                        this.ngxLogger.error(error.message);
                        throw error;
                    });
                    this.subscribers.push(deleteConSubscriber);
                });
                break;
            case 2:
                this.alertService.showDialog('Weet je zeker dat je wilt verwijderen?', DialogType.confirm, () => {
                    const deleteConSubscriber = this.gasContractService.delete(contractId).subscribe(res => {
                        this.alertService.showMessage('Gascontract', 'Met succes verwijderd!', MessageSeverity.success);
                        this.getById();
                    }, error => {
                        this.ngxLogger.error(error.message);
                        throw error;
                    });

                    this.subscribers.push(deleteConSubscriber);
                });
                break;
            case 3:
                this.alertService.showDialog('Weet je zeker dat je wilt verwijderen?', DialogType.confirm, () => {
                    const deleteConSubscriber = this.electricityContractService.delete(contractId).subscribe(res => {
                        this.alertService.showMessage('Injectiecontract', 'Met succes verwijderd!', MessageSeverity.success);
                        this.getById();
                    }, error => {
                        this.ngxLogger.error(error.message);
                        throw error;
                    });

                    this.subscribers.push(deleteConSubscriber);
                });
                break;

            default:
                break;
        }
    }

    deleteCustomerFromGroup(customerId: number, linkedCustomeId: number) {
        this.alertService.showDialog('Weet je zeker dat je wilt verwijderen?', DialogType.confirm, () => {
            const deleteCUstMappSubscriber = this.customersService.deleteCustomerFromGroup(customerId, linkedCustomeId).subscribe(res => {
                this.getLinkedGroup();
            }, error => {
                this.ngxLogger.error(error.message);
                throw error;
            });
            this.subscribers.push(deleteCUstMappSubscriber);
        });
    }

    exportExcel() {
        if (this.contractBases.length > 0) {
            let ids: string = "0";
            if (this.selectedContracts && this.selectedContracts.length > 0) {
                ids = this.selectedContracts.map(z => z.Id).toString();
            } else {
                ids = this.contractBases.map(z => z.Id).toString();
            }
            this.alertService.showMessage('Contracten', 'Bestandsdownload is bezig!', MessageSeverity.info);
            const expostFileSubscriber = this.contractBaseService.exportExcel(ids).subscribe(data => {
                saveAs(data, 'KlantContracten.xlsx');
                this.alertService.showMessage('Contracten', 'Bestandsdownload voltooid!', MessageSeverity.info);
            }, error => {
                this.ngxLogger.error(error.message);
                throw error;
            });
            this.subscribers.push(expostFileSubscriber);
        } else {
            this.alertService.showMessage('Contracten', 'Geen enkel contract gevonden!', MessageSeverity.warn);
        }
    }

    showErrorAlert(caption: string, message: string) {
        this.alertService.showMessage(caption, message, MessageSeverity.error);
    }

    showDialog(data: any) {
        this.selectedData = data;
        if (data.EANCode) {
            this.display1 = true;
        } else {
            this.display2 = true;
        }
    }

    ngOnDestroy(): void {
        if (this.subscribers) {
            this.subscribers.forEach(s => s.unsubscribe());
        }
    }

    get canviewCustomers() {
        return this.accountService.userHasPermission(Permission.viewCustomersPermission);
    }

    get canmanageCustomers() {
        return this.accountService.userHasPermission(Permission.manageCustomersPermission);
    }

    get canaddCustomers() {
        return this.accountService.userHasPermission(Permission.addCustomersPermission);
    }

    get caneditCustomers() {
        return this.accountService.userHasPermission(Permission.editCustomersPermission);
    }

    get candeleteCustomers() {
        return this.accountService.userHasPermission(Permission.deleteCustomersPermission);
    }

    get canlistCustomers() {
        return this.accountService.userHasPermission(Permission.listCustomersPermission);
    }

    get canviewDeliveryAddress() {
        return this.accountService.userHasPermission(Permission.viewDeliveryAddressPermission);
    }

    get canmanageDeliveryAddress() {
        return this.accountService.userHasPermission(Permission.manageDeliveryAddressPermission);
    }

    get canaddDeliveryAddress() {
        return this.accountService.userHasPermission(Permission.addDeliveryAddressPermission);
    }

    get caneditDeliveryAddress() {
        return this.accountService.userHasPermission(Permission.editDeliveryAddressPermission);
    }

    get candeleteDeliveryAddress() {
        return this.accountService.userHasPermission(Permission.deleteDeliveryAddressPermission);
    }

    get canlistDeliveryAddress() {
        return this.accountService.userHasPermission(Permission.listDeliveryAddressPermission);
    }

    get canelectricityContractAdd() {
        return this.accountService.userHasPermission(Permission.electricityContractAddPermission);
    }

    get canelectricityContractEdit() {
        return this.accountService.userHasPermission(Permission.electricityContractEditPermission);
    }

    get canelectricityContractDelete() {
        return this.accountService.userHasPermission(Permission.electricityContractDeletePermission);
    }

    get canelectricityContractView() {
        return this.accountService.userHasPermission(Permission.electricityContractViewPermission);
    }

    get canelectricityContractList() {
        return this.accountService.userHasPermission(Permission.electricityContractListPermission);
    }

    get caninjectionContractAdd() {
        return this.accountService.userHasPermission(Permission.injectionContractAddPermission);
    }

    get caninjectionContractEdit() {
        return this.accountService.userHasPermission(Permission.injectionContractEditPermission);
    }

    get caninjectionContractDelete() {
        return this.accountService.userHasPermission(Permission.injectionContractDeletePermission);
    }

    get caninjectionContractView() {
        return this.accountService.userHasPermission(Permission.injectionContractViewPermission);
    }

    get caninjectionContractList() {
        return this.accountService.userHasPermission(Permission.injectionContractListPermission);
    }

    get canGASContractAdd() {
        return this.accountService.userHasPermission(Permission.gasContractAddPermission);
    }

    get canGASContractEdit() {
        return this.accountService.userHasPermission(Permission.gasContractEditPermission);
    }

    get canGASContractDelete() {
        return this.accountService.userHasPermission(Permission.gasContractDeletePermission);
    }

    get canGASContractView() {
        return this.accountService.userHasPermission(Permission.gasContractViewPermission);
    }

    get canGASContractList() {
        return this.accountService.userHasPermission(Permission.gasContractListPermission);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/customers/customers-add-update.component.ts